import { Observable } from 'rxjs/internal/Observable';
import { XOR } from '../../../utils/types-utils';

export interface AppcloudCredentialsLoginInterface {
    submitLoginForm(credential: AppcloudCredential): void;
    isLoading$: Observable<boolean>;
    loadingMessages$: Observable<string[]>;
    accounts: Account[];
    loginError: LoginError;
}

export type AppcloudCredential = {
    password: string;
    accountId?: number | null;
} & XOR<{ username: string }, { email: string }>;

export class Account {
    id?: number;
    name?: string;

    description?: string;
    sfAccountId?: string;
    createdAt?: any;
    updatedAt?: any;
}

export type LoginError = {
    error: {
        error: string;
        error_description: string;
        failedAttempts?: string;
    };
};
